var LoaderService = function ($injector, $q, $timeout, $rootScope, $log, apiStat) {

    var MIN_TIME_LOADER_SHOW = 600;

    function race(promiseAction1, promiseAction2) {
        var d = $q.defer();
        promiseAction1.then(d.resolve);
        promiseAction2.then(d.resolve);
        return d.promise;
    }

    function wait(ms) {
        var d = $q.defer();
        setTimeout(d.resolve, ms);
        return d.promise;
    }

    function takeOneEvent(scope, eventName) {
        var d = $q.defer();
        var sbscr = scope.$on(eventName, function (data) {
            d.resolve(data);
            sbscr();
        });
        return d.promise;
    }

    /* execute promise action not less then @ms time */
    function executeActionMinTime(promiseAction, ms) {
        var start = new Date().getTime();
        return $q.all([promiseAction, wait(ms)]).then(function (data) {
            var end = new Date().getTime();
            if (end - start < ms) {
                return wait(ms - end + start).then(function () {
                    return data[0]
                });
            }
            return data[0];
        });
    }

    var services = {};

    this.getOrCreate = function (name, $scope) {
        if (services[name]) return services[name];
        else return services[name] = new Loader(name, $scope)
    };


    var Loader = function (name, $scope) {

        var showActions = {};
        var showPromise;
        var showTimestamp;
        var hidePromise;
        var self = this;

        this.isShowed = false;

        var promiseCounter = 0;

        function addPromiseNew(promiseAction, showLoaderAction, hideLoaderAction, waitTime) {
            return race(promiseAction, wait(waitTime || 0)).then(function (value) {
                if (value) return value;
                return executeActionMinTime($q.all([showLoaderAction(), promiseAction]), MIN_TIME_LOADER_SHOW)
                    .finally(function (data) {
                        return hideLoaderAction().then(function () {
                            return data;
                        });
                    });
            });

        }


        this.addPromise = function (promise, options) {
            if (!_.isFunction(_.get(promise, 'finally')))
                return promise;

            if (_.isBoolean(options)) options = { autoShow: options };
            options = _.defaults(options, { autoShow: true });

            var action = "promise__" + promiseCounter++;

            var showLoaderAction = function () {
                if (options.autoShow) this.show(action, options);
                return $q.when(true);
            }.bind(this);

            var hideLoaderAction = function () {
                this.hide(action);
                return $q.when(true);
            }.bind(this);

            var promiseAction = promise.then(function (data) {
                return { data: data };
            });

            var mean = apiStat.getMean();
            var std = apiStat.getSTD();

            return addPromiseNew(promiseAction, showLoaderAction, hideLoaderAction, MIN_TIME_LOADER_SHOW >= mean + 2 * std ? mean + 2 * std : 0).then(function (data) {
                return data.data;
            });
        };

        /*
         ** @action  is action name
         */
        this.show = function (action, options) {

            options = _.defaults(options, {});
            showActions[action] = options;

            $log.debug("LoaderService (show) :: " + name, action, _.size(showActions), options);

            if (hidePromise) {
                $timeout.cancel(hidePromise);
                hidePromise = null;
            }

            if (showPromise) return;

            if (!showPromise) {
                showPromise = $timeout(function () {
                    showPromise = null;
                    self.isShowed = true;
                    showTimestamp = new Date().getTime();
                    //$log.debug('isShowed', this.isShowed);
                    $rootScope.$emit("LoaderService__" + name + "__" + "show");
                    $scope && $scope.$applyAsync();
                }.bind(this));
            }
        };

        this.hide = function (action) {
            var options = showActions[action];
            if (!options) return;
            delete showActions[action];

            $log.debug("LoaderService (hide) :: " + name, action, _.size(showActions), options);

            if (hidePromise || _.size(showActions) > 0) return;

            if (showPromise) {
                $timeout.cancel(showPromise);
                showPromise = null;
            }

            if (!hidePromise) {
                var s = Math.max((options.minShowTime > 0) ? (options.minShowTime - (new Date().getTime() - showTimestamp) / 1000) : 10, 10);
                hidePromise = $timeout(function () {
                    hidePromise = null;
                    self.isShowed = false;
                    $rootScope.$emit("LoaderService__" + name + "__" + "hide");
                    $scope && $scope.$applyAsync();
                }.bind(this), s);
            }
        };

        this.onHide = function (listener) {
            $rootScope.$on("LoaderService__" + name + "__" + "hide", listener);
        };

        this.onShow = function (listener) {
            $rootScope.$on("LoaderService__" + name + "__" + "show", listener);
        };

        return this;
    };

    var loader = $rootScope.changeStateLoader = this.getOrCreate("changeStateLoader", $rootScope);

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        //(toParams.loader || loader).show('changeState');
        // call changeState loader by addPromise method
        (toParams.loader || loader).addPromise(
            race(
                takeOneEvent($rootScope, '$stateChangeSuccess'),
                takeOneEvent($rootScope, '$stateChangeError')
            )
        );
    });
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        //$timeout(function () {
        //    (toParams.loader || loader).hide('changeState');
        //}.bind(this), 0)

    });
    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
        //loader.hide('changeState');
    });

    this.pendingSubscribe = function (scope, callback) {
        // Store unsubscribe function in 'handler' variable;
        var handler = $rootScope.$on('notifying-service-event', callback);
        scope.$on('$destroy', handler);
    }

    this.pendingNotify = function (val) {
        $rootScope.$emit('notifying-service-event', val);
    }

    return {
        getOrCreate: this.getOrCreate,
        pendingSubscribe: this.pendingSubscribe,
        pendingNotify: this.pendingNotify
    };
};
LoaderService.$inject = ['$injector', '$q', '$timeout', '$rootScope', '$log', 'apiStat'];

function ChangeStateLoaderService(LoaderService) {
    return LoaderService.getOrCreate("changeStateLoader");
}

ChangeStateLoaderService.$inject = ['LoaderService'];

module.exports = {
    LoaderService: LoaderService,
    ChangeStateLoaderService: ChangeStateLoaderService
}
